import ImageView, { imageViewUpdateFn } from './ImageView';
import MeetingTimesView, { meetingTimesViewUpdateFn } from './MeetingTimesView';
import Unsubscribe, { unsubscribeViewUpdateFn } from './Unsubscribe';
import { PersonalizationTokenView, personalizationTokenViewUpdateFn } from './PersonalizationTokenView';
export const viewConfig = {
  image: {
    component: ImageView,
    updateFn: imageViewUpdateFn
  },
  meetingTimesBlock: {
    component: MeetingTimesView,
    updateFn: meetingTimesViewUpdateFn
  },
  unsubscribe: {
    component: Unsubscribe,
    updateFn: unsubscribeViewUpdateFn
  },
  personalization_token: {
    component: PersonalizationTokenView,
    updateFn: personalizationTokenViewUpdateFn
  }
};